import Head from 'next/head';

export default function Linkaufbau() {
    return (
        <div className="flex flex-col min-h-screen bg-gray-100 dark:bg-gray-900">
            <Head>
                <title>Seo Audit Services | deinSEOExpert</title>
                <link rel="icon" href="/favicon.ico"/>
                <meta
                    name="description"
                    content="Entdecken Sie mein Seo Audit Service und erfahren Sie mehr über meine professionellen SEO-Dienstleistungen. Als Ihr SEO-Experte biete ich maßgeschneiderte Lösungen und kompetente Beratung, um Ihren SEO-Erfolg zu maximieren. Besuchen Sie meine Website für Expertenwissen und gezielte Keyword-Optimierung."
                />
            </Head>

            <main className="p-6 flex flex-col-reverse md:flex-row max-w-5xl mx-auto">
                <div className="w-full md:w-2/3 pr-4 mb-4 md:mb-0 order-2 md:order-1">
                    <div className="flex items-center mb-6">
                        <span className="inline-block mr-4 text-4xl">🔍</span>
                        <h2 className="text-3xl font-bold text-green-700">SEO-Audit-Dienstleistungen</h2>
                    </div>
                    <p className="text-lg leading-relaxed text-gray-700 mb-10 dark:text-white">Meine SEO-Audit-Dienstleistungen bieten
                        eine umfassende Analyse der Leistung Ihrer Website und identifizieren Bereiche zur Verbesserung
                        und Optimierung. Ich bewerte verschiedene Faktoren wie On-Page-Elemente, technisches SEO,
                        Backlink-Profil, Seitenladezeit und Benutzererfahrung. Durch ein gründliches SEO-Audit kann
                        ich Probleme aufdecken, die sich auf Ihr Suchmaschinen-Ranking auswirken könnten, und
                        Empfehlungen zur Verbesserung der Sichtbarkeit Ihrer Website und des organischen Traffics
                        geben.</p>
                    <h2 className="text-2xl font-bold text-green-700 mb-4">Warum meine SEO-Audit-Dienstleistungen
                        wählen?</h2>
                    <p className="text-lg leading-relaxed text-gray-700 dark:text-white">Als SEO-Experte spezialisiere ich mich darauf,
                        detaillierte SEO-Audits anzufertigen, die auf Ihre spezifischen Bedürfnisse zugeschnitten sind.
                        Ich nutze führende Tools und bewährte Verfahren, um die Leistung Ihrer Website zu bewerten und
                        Optimierungsmöglichkeiten zu identifizieren. Indem ich zugrunde liegende Probleme angehe und
                        effektive Strategien umsetze, kann ich Ihnen helfen, die allgemeine SEO-Gesundheit Ihrer
                        Website zu verbessern und langfristigen Erfolg in den Suchmaschinen-Rankings zu erzielen.</p>
                </div>

                <div className="w-full md:w-1/3 pl-4 order-1 md:order-2">
                    <div className="bg-white p-6 rounded shadow-md dark:bg-gray-800">
                        <img src="/seoAudit.webp" alt="Seo Audit" className="w-full mb-6 rounded"/>
                        <h3 className="text-xl font-bold text-green-700 mb-2">Ihr SEO-Experte</h3>
                        <p className="text-gray-700 mb-4 dark:text-white">Als SEO-Experte, spezialisiert auf
                            SEO-Audit-Dienstleistungen, kann ich Ihnen mit meiner umfassenden Analyse und
                            strategischen Empfehlungen helfen, Ihre Website zu optimieren und ihre
                            Suchmaschinen-Performance zu verbessern.</p>
                    </div>
                </div>
            </main>
        </div>
    );
}